export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const APPLY_COUPON = 'APPLY_COUPON';
export const CLEAR_CART = 'CLEAR_CART';
export const LOAD_PRODUCTS = 'LOAD_PRODUCTS';